"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onEscapePress = exports.onEnterPress = exports.getFullWidth = exports.measureWidth = exports.getPlatform = exports.PlatformEnum = exports.getHslFromString = exports.globalColorClasses = exports.getValueTrend = exports.getSign = exports.classNames = void 0;
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
exports.classNames = classNames;
const getSign = (value = 0) => (value >= 0 ? '+' : '-');
exports.getSign = getSign;
const getValueTrend = (value = 0) => {
    const adaptValue = typeof value === 'number' ? value : parseFloat(value);
    if (adaptValue > 0)
        return 'text-success-500';
    if (adaptValue < 0)
        return 'text-danger-500';
    return 'text-secondary-500';
};
exports.getValueTrend = getValueTrend;
exports.globalColorClasses = {
    focus: 'focus:outline-none focus-visible:ring-offset-0 focus-visible:ring-4 focus-visible:ring-accent-300',
    disabled: 'opacity-50 cursor-not-allowed',
};
function getHslFromString(stringInput = '') {
    const stringUniqueHash = [...stringInput]
        // eslint-disable-next-line no-bitwise
        .reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
    return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
}
exports.getHslFromString = getHslFromString;
var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["WindowsOS"] = "Win";
    PlatformEnum["MacOS"] = "Mac";
    PlatformEnum["UnixOS"] = "X11";
    PlatformEnum["LinuxOS"] = "Linux";
})(PlatformEnum = exports.PlatformEnum || (exports.PlatformEnum = {}));
const getPlatform = () => {
    if (navigator.userAgent.indexOf(PlatformEnum.WindowsOS) !== -1)
        return PlatformEnum.WindowsOS;
    if (navigator.userAgent.indexOf(PlatformEnum.MacOS) !== -1)
        return PlatformEnum.MacOS;
    if (navigator.userAgent.indexOf(PlatformEnum.UnixOS) !== -1)
        return PlatformEnum.UnixOS;
    if (navigator.userAgent.indexOf(PlatformEnum.LinuxOS) !== -1)
        return PlatformEnum.LinuxOS;
    return null;
};
exports.getPlatform = getPlatform;
const measureWidth = (text) => {
    const ele = document.createElement('div');
    ele.style.position = 'absolute';
    ele.style.visibility = 'hidden';
    ele.style.whiteSpace = 'nowrap';
    ele.style.left = '-9999px';
    ele.innerHTML = text;
    document.body.appendChild(ele);
    const width = ele.offsetWidth;
    document.body.removeChild(ele);
    return width;
};
exports.measureWidth = measureWidth;
const getFullWidth = (el, withPadding = false) => {
    const style = window.getComputedStyle(el);
    const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    const border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    const width = el.offsetWidth || (0, exports.measureWidth)(el.innerHTML);
    return width + margin + (withPadding ? 1 : 0) * padding + border;
};
exports.getFullWidth = getFullWidth;
const onEnterPress = (cl) => ((event) => {
    if (event.key === 'Enter')
        cl(event);
});
exports.onEnterPress = onEnterPress;
const onEscapePress = (cl) => ((event) => {
    if (event.key === 'Escape')
        cl(event);
});
exports.onEscapePress = onEscapePress;
//# sourceMappingURL=utils.js.map